import { DiscrepancyReport, DiscrepancyReportRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const createDiscrepancyReport: (
  fetchContext: FetchContext,
  discrepancyReport: DiscrepancyReport,
  accessToken?: string,
) => Promise<DiscrepancyReportRef> = async (fetchContext, discrepancyReport, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/discrepancy-report`,
  {
    method: 'POST',
    body: JSON.stringify(discrepancyReport),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<DiscrepancyReportRef>(fetchContext.errorStore, response, 'create discrepancy report'));
